export default __webpack_public_path__ + "static/media/FileZilla.c909bbf8.png";